import { Result } from '@/types/api'
import request from '@/utils/request'
import type { LoginParams, LoginResult, UserInfo, SysUserInfo, RegisterForm } from '@/types/user'


export const login = (data: LoginParams) => {
  return request.post<LoginResult>('/auth/login', data)
}

// 注册
export const register = async (data: RegisterForm): Promise<{data:Result}> => {
  const res =  await request.post('/auth/register', data)
  // 包一层 data，兼容 res.data.code 用法
  return { data: res as unknown as Result }
}



// 发送验证码，返回 {data: {code, msg, data}}
export const sendCode = async (phone: string): Promise<{ data: Result }> => {
  const res = await request.get(`/auth/getPhoneCode/${phone}`)
  // 包一层 data，兼容 res.data.code 用法
  return { data: res as unknown as Result }
}


// 获取用户信息
export const getUserInfo = () => {
  return request.get<UserInfo>('/auth/getUserInfo')
}

// 更新用户信息
export const updateUserInfo = async (data: Partial<SysUserInfo>): Promise<{data:Result}> => {
  const res = await request.post('/auth/updateUserInfo', data)
  // 包一层 data，兼容 res.data.code 用法
  return { data: res as unknown as Result }
}
